import { render, staticRenderFns } from "./ksSearch.vue?vue&type=template&id=a2b9ef8c&scoped=true"
import script from "./ksSearch.vue?vue&type=script&lang=js"
export * from "./ksSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b9ef8c",
  null
  
)

export default component.exports